import { useTranslation } from "react-i18next"


const LanguageSwitcher = () => {

    const [t, i18n] = useTranslation()

    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang)
        localStorage.setItem("lang", lang)
    }

    return (
        <div>
            <button className="btn btn-sm" onClick={() => handleChangeLanguage("en")}>
                <img
                    src="https://flagcdn.com/w40/gb.png"
                    width="32"
                    height="24"
                    alt="United Kingdom" />
            </button>
            <button className="btn btn-sm"  onClick={() => handleChangeLanguage("it")}>
            <img
                    src="https://flagcdn.com/w40/it.png"
                    width="32"
                    height="24"
                    alt="Italy" />
            </button>
        </div>
    )

}

export default LanguageSwitcher